// @avantia common-code
import { registerConfigurationAction } from '../config/registerClientConfig';
import { toLowerCase } from '../tools/clientAndServerUtilities';
import { getCookie, setCookie } from '../tools/clientCookies';
import { HpCookies } from '../types';

let answersKey: string, productKey: string;
registerConfigurationAction((config) => {
  ({ answersKey, productKey } = config);
});

export function getAnswersIdCookie(cookies?: HpCookies): string | undefined {
  return getCookie(answersKey, cookies) || undefined;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function setAnswersIdCookie(answersId: string | undefined, cookies?: HpCookies): void {
  if (answersId) {
    setCookie({ name: answersKey, value: toLowerCase(answersId) || '' }, cookies);
  }
}

export function getProductIdCookie(cookies?: HpCookies): string | undefined {
  return getCookie(productKey, cookies) || undefined;
}

export function setProductIdCookie(productId: string, cookies?: HpCookies): void {
  setCookie({ name: productKey, value: toLowerCase(productId) || '' }, cookies);
}
